import { Injectable } from '@angular/core';
import { Http,Response , Headers } from '@angular/http';
import { Config } from '../../../config/config';
import { VnptHttpService } from '../../services/vnpt-http.service';
import { Observable }     from 'rxjs/Observable';
import { DMThietBi } from './dm-thiet-bi';
import { DMThietBiComponent } from './dm-thiet-bi.component';
import { AuthService } from '../../services/auth.service';
@Injectable()
export class DMThietBiService {

    controller:string = 'DM_Thietbi';
    constructor(private http: Http) { }
        
    GetTreeList(KeyWord: string) {
        let headers = new Headers();
        headers.append("Content-Type", "application/json;charset=utf-8");
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));
        return this.http.get(Config.apiUrl + this.controller + '/Tree?KeyWord=' + KeyWord, { headers: headers }).map(resp => resp.json());
    }
    GetTreeListTD(IdDonVi, KeyWord: string) {
        let headers = new Headers();
        headers.append("Content-Type", "application/json;charset=utf-8");
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));
        let data = {
            IdDonVi:IdDonVi,
            keyWord:KeyWord
        }
        return this.http.post(Config.apiUrl + this.controller + '/TreeTD',JSON.stringify(data), { headers: headers }).map(resp => resp.json());
    }
    GetTreeListGroup() {
        let headers = new Headers();
        headers.append("Content-Type", "application/json;charset=utf-8");
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));
        return this.http.post(Config.apiUrl + this.controller + '/TreeGroup', JSON.stringify({}), { headers: headers }).map(resp => resp.json());
    }
    GetTreeListGroupDV(iddonvi:number) {
        let headers = new Headers();
        headers.append("Content-Type", "application/json;charset=utf-8");
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));
        return this.http.get(Config.apiUrl + this.controller + '/TreeGroupDV?IdDonVi=' + iddonvi, { headers: headers }).map(resp => resp.json());
    }
    GetListChild(paging: number, pagesize: number, keyword: string, idDonVi: number, idThietBi: number, idLoaiThietBi: number, idHangSanXuat: number) {
        let headers = new Headers();
        let startRowIndex = paging - 1;

        headers.append("Content-Type", "application/json;charset=utf-8");
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));
        return this.http.get(Config.apiUrl + this.controller + '/GetListChild?offset=' + startRowIndex + "&pagesize=" + pagesize + "&keyword=" + keyword + "&idDonVi=" + idDonVi + "&idThietBi=" + idThietBi + "&idLoaiThietBi=" + idLoaiThietBi + "&idHangSanXuat=" + idHangSanXuat, { headers: headers }).map(resp => resp.json());
    }
    GetListChildTD(paging: number, pagesize: number, keyword: string, idCoQuan: number, idThietBi: number, idLoaiThietBi: number, idHangSanXuat: number) {
        let headers = new Headers();
        let startRowIndex = paging - 1;

        headers.append("Content-Type", "application/json;charset=utf-8");
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));
        return this.http.get(Config.apiUrl + this.controller + '/GetListChildTD?offset=' + startRowIndex + "&pagesize=" + pagesize + "&keyword=" + keyword + "&idCoQuan=" + idCoQuan + "&idThietBi=" + idThietBi + "&idLoaiThietBi=" + idLoaiThietBi + "&idHangSanXuat=" + idHangSanXuat, { headers: headers }).map(resp => resp.json());
    }
    GetListDeviceChild(paging: number, pagesize: number, keyword: string, idDonVi: number,  idThietBi: number,idLoaiThietBi: number,) {
        let headers = new Headers();
        let startRowIndex = paging - 1;

        headers.append("Content-Type", "application/json;charset=utf-8");
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));
        return this.http.get(Config.apiUrl + this.controller + '/GetListDeviceChild?offset=' + startRowIndex + "&pagesize=" + pagesize + "&keyword=" + keyword + "&idDonVi=" + idDonVi + "&idThietBi=" + idThietBi+"&idLoaiThietBi="+idLoaiThietBi, { headers: headers }).map(resp => resp.json());
    }
    GetListDeviceAll(paging: number, pagesize: number, keyword: string, idDonVi: number,  idThietBi: number,idLoaiThietBi: number,) {
        let headers = new Headers();
        let startRowIndex = paging - 1;

        headers.append("Content-Type", "application/json;charset=utf-8");
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));
        return this.http.get(Config.apiUrl + this.controller + '/GetListDeviceAll?offset=' + startRowIndex + "&pagesize=" + pagesize + "&keyword=" + keyword + "&idDonVi=" + idDonVi + "&idThietBi=" + idThietBi+"&idLoaiThietBi="+idLoaiThietBi, { headers: headers }).map(resp => resp.json());
    }
    DanhSach_ThietBi_IdLoaiThietBi(TB){
        let headers = new Headers();        
        headers.append("Content-Type", "application/json;charset=utf-8");        
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));
        let data = TB;
        return this.http.post(Config.apiUrl + 'DM_ThietBi/DanhSach_ThietBi_LoaiThietBi', JSON.stringify(data), { headers: headers }).map(resp => resp.json());
    }
    GetList(paging:number,maxSize:number, keyword: string,idloaithietbi: number, idcoquan:number) {
        let headers = new Headers();
        let currentPage = paging - 1;
       
        headers.append("Content-Type", "application/json;charset=utf-8");        
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));

        return this.http.get(Config.apiUrl +this.controller+ "/GetList?offset="+ currentPage+"&pageSize="+ maxSize + "&keyword=" + keyword+ "&idloaithietbi=" + idloaithietbi + "&iddonvi=" + idcoquan, { headers: headers }).map(resp => resp.json());       
    }
    Save(item:DMThietBi) {   
        let headers = new Headers();
        headers.append("Content-Type", "application/json;charset=utf-8");
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));
        let data = item;
        return this.http.post(Config.apiUrl + this.controller+'/save', JSON.stringify(data), { headers: headers }).map(resp => resp.json());
    }
    Delete(item:DMThietBi) {      
        let headers = new Headers();
        
        headers.append("Content-Type", "application/json;charset=utf-8");
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));
        let data = { Id : item.Id };
        return this.http.post(Config.apiUrl + this.controller+'/Delete', JSON.stringify(data), { headers: headers }).map(resp => resp.json());
    }
    DongBoTuPrtg(paging:number,maxSize:number, keyword: string,idloaithietbi: number, iddonvi:number, iddongthietbi: number, iddoituong: number) {
        let headers = new Headers();
        let currentPage = paging - 1;
       
        headers.append("Content-Type", "application/json;charset=utf-8");        
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));

        return this.http.get(Config.apiUrl +this.controller+ "/DongBoTuPrtg?offset="+ currentPage+"&pageSize="+ maxSize + "&keyword=" + keyword+ "&idloaithietbi=" + idloaithietbi + "&iddonvi=" + iddonvi + "&iddongthietbi=" + iddongthietbi + "&iddoituong=" + iddoituong, { headers: headers }).map(resp => resp.json());       
    }
    GetListPrtg(paging:number,maxSize:number, keyword: string,idloaithietbi: number, iddonvi:number, iddongthietbi: number, iddoituong: number) {
        let headers = new Headers();
        let currentPage = paging - 1;
       
        headers.append("Content-Type", "application/json;charset=utf-8");        
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));

        return this.http.get(Config.apiUrl +this.controller+ "/GetListPrtg?offset="+ currentPage+"&pageSize="+ maxSize + "&keyword=" + keyword+ "&idloaithietbi=" + idloaithietbi + "&iddonvi=" + iddonvi + "&iddongthietbi=" + iddongthietbi + "&iddoituong=" + iddoituong, { headers: headers }).map(resp => resp.json());       
    }
}


// WEBPACK FOOTER //
// D:/1.eGovD/CITIZEN/sources/citizen-admin/Angular/src/app/thiet-bi/dm-thiet-bi/dm-thiet-bi.service.ts